import React, { useState } from "react";
import useExperience from "../../../hooks/useExperience";
import { IBLSpinLoader } from "../../IBLSpinLoader";
import PositionMenu from "./PositionMenu/PositionMenu";
import { NoItemView } from "../../NoItemView";
import { inIframe } from "../../../utils";
import { api, getTenant } from "../../../hooks";



const Experience = ({username, t}) => {
 
  const { experience, experienceDataLoaded, setExperience, setExperienceDataLoaded } = useExperience(username);
  const [showPositionMenu, setShowPositionMenu] = useState(false);
  const [positionData, setPositionData] = useState({
    id :"",
    company_id: 0,
    title: "",
    employment_type: "Full Time",
    location: "",
    start_date: "",
    end_date: "",
    is_current: false,
    description: "",
    start_month: "",
    end_month: "",
    start_year: "",
    end_year: ""
  });

  const handleSuccess = () => {
    setShowPositionMenu(false);
    setExperienceDataLoaded(false);
    api.ibldmcareer.getExperience(
      { org: getTenant(), username: username },
      (data) => {
        setExperience(Array.isArray(data) ? data : []);
        setExperienceDataLoaded(true);
      },
      (error) => {
        setExperienceDataLoaded(true);
        setExperience([]);
      }
    );
  }
  
  const handlePositionEdit = (experience) => {
    const startDate = experience.start_date ? new Date(experience.start_date) : null;
    const endDate = experience.end_date ? new Date(experience.end_date) : null;

    const formattedData = {
      id: experience.id,
      company_id: experience.company.id,
      title: experience.title,
      employment_type: experience.employment_type,
      location: experience.location,
      start_date: startDate ? new Date(startDate).toLocaleString('default', { month: 'long' }) : "",
      end_date: endDate ? new Date(endDate).toLocaleString('default', { month: 'long' }) : "",
      is_current: experience?.is_current || false,
      description: experience.description,
      start_year: startDate ? String(startDate.getFullYear()) : "",
      end_year: endDate ? String(endDate.getFullYear()) : "",
      start_month: startDate ? new Date(startDate).toLocaleString('default', { month: 'long' }) : ""  ,
      end_month: endDate ? new Date(endDate).toLocaleString('default', { month: 'long' }) : "",
    };
    setPositionData(formattedData);
    setShowPositionMenu(true);
  }

    return (
<>

        <div
          data-w-tab="Tab 2"
          className={`public-profile-inner-tabs-content-block w-tab-pane w--tab-active`}
          id="w-tabs-0-data-w-pane-1"
          role="tabpanel"
          aria-labelledby="w-tabs-0-data-w-tab-1"
        >
          <div className="div-block-502">
            <div className="text-block-272 pr_t">{t('Work Experience')}</div>
            <div className="w-layout-vflex flex-block-46">
              {!experienceDataLoaded ? (
                <IBLSpinLoader size={40} containerHeight={'200px'} />
              ) : experience.length > 0 ? (
                experience.map((item, index) => (
                  <div className="w-layout-vflex" key={index}>
                    <div className="w-layout-hflex flex-block-61">
                      <div className="w-layout-hflex flex-block-60"  style={{display: "none"}} />
                      <div className="w-layout-vflex flex-block-58">
                        <div className="w-layout-hflex flex-block-62">
                          <h4 className="heading-16">{item?.title}</h4>
                          <div className="html-embed-20 spaced w-embed" onClick={() => handlePositionEdit(item)} style={{ cursor: "pointer", display: !inIframe() ? "" : "none"}} >
                            <svg
                              xmlns="http://www.w3.org/svg/2000"
                              className="image-24 home child-svg"
                              width="auto"
                              height={512}
                              viewBox="0 0 512 512"
                              version="1.1"
                            >
                              <path d="" stroke="none" fill="#080404" fillRule="evenodd" />
                              <path
                                d="M 379.500 1.346 C 377.300 2.074, 373.475 3.690, 371 4.935 C 367.742 6.575, 319.505 54.150, 196.187 177.350 C 102.514 270.933, 23.908 350.091, 21.506 353.257 C 19.104 356.423, 16.258 361.373, 15.181 364.257 C 12.345 371.853, -0.390 470.010, 0.222 479.555 C 1.337 496.937, 15.393 510.747, 33 511.758 C 43.042 512.335, 140.019 499.712, 147.743 496.823 C 150.627 495.744, 155.577 492.897, 158.743 490.495 C 161.909 488.094, 241.263 409.263, 335.083 315.315 C 529.928 120.205, 511.500 140.503, 511.500 121 C 511.500 103.446, 513.496 106.104, 460.204 52.707 C 407.453 -0.147, 408.665 0.793, 392.602 0.300 C 386.982 0.128, 381.970 0.528, 379.500 1.346 M 365.498 80.002 L 340.509 105.006 373.754 138.251 L 406.999 171.496 432.001 146.494 L 457.003 121.492 423.745 88.245 L 390.487 54.998 365.498 80.002 M 183.624 261.876 L 62.756 382.747 57.795 420.458 C 55.067 441.198, 53.070 458.403, 53.357 458.691 C 53.645 458.978, 70.840 456.970, 91.569 454.228 L 129.257 449.242 250.131 328.368 L 371.005 207.494 337.749 174.249 L 304.493 141.004 183.624 261.876"
                                stroke="none"
                                fill="var(--accent)"
                                fillRule="evenodd"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="w-layout-hflex flex-block-59">
                          <a href={item?.company?.website} className="tab-content-text link">
                            {item?.company?.name}
                          </a>
                          <div className="tab-content-text">|</div>
                          <div className="tab-content-text">{new Date(item?.start_date).getFullYear()} -  {item?.end_date ? new Date(item?.end_date).getFullYear() : 'Present'}</div>
                        </div>
                      </div>
                    </div>
                    <div className="text-block-403">
                      {item?.description}
                    </div>
                  </div>
                ))
              ) : (
                    <NoItemView
                      displayMessage={t('You don\'t have any experience data yet.')}
                      imageUrl={'/images/tools.png'}
                      displayPadding={false}
                    />
              )}
            </div>
          </div>
        </div>

 {showPositionMenu && (
          <div className="popup_div active">
            <div className="popup_cont sk">

              <PositionMenu setShowPositionMenu={setShowPositionMenu} handleSuccess={handleSuccess} menuTitle={t('Edit Position')} positionData={positionData} setPositionData={setPositionData} isUpdate={true} />

    </div>
  </div>
      )}
</>

    
    );
}

export default Experience;